import React, { useEffect, useState } from "react";
import { Link, useHistory, withRouter } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import TranslationService from "../../Services/translationService";
import ApiService from "../../Services/apiService";
import {
	CONSULTANT_CONSULTATION_CONTRACTS_KEY,
	STUDENT_CONSULTATION_CONTRACTS_KEY,
	CONSULTANT_KEY,
	CREATE_ONE_TIME_WEBINAR_KEY,
} from "../../Constants/urlKeys";
import { ERROR_KEY } from "../../Constants/mainKeys";
import AlertService from "../../Services/alertService";
import Auxiliary from "../../hoc/auxiliary/auxiliary";
import callWeitingRingtone from "./../../assets/audio/duooutgoing_b9801c9f5127101.mp3";
import { setIsShowB2BWebinarNotification } from "../../Store/Actions/main";

const B2bWebinarNotificationBlock = props => {
	const { isShow } = props;
	const dispatch = useDispatch();
	let history = useHistory();
	const [translationService, setTranslationService] = useState(null);
	const translations = useSelector(state => state.translation.translations);
	const language = useSelector(state => state.language.language);
	const user = useSelector(state => state.user.user);

	useEffect(() => {
		setTranslationService(new TranslationService(translations));
	}, [translations]);

	useEffect(() => {
		if (isShow) {
			audioStart();
		}
	}, [isShow, document.getElementById("waiting-ringtone")]);

	const audioStart = () => {
		var audioElement = document.getElementById("waiting-ringtone");
		if (audioElement) {
			audioElement.src = callWeitingRingtone;
			audioElement.autoplay = true;
			audioElement.loop = true;
		}
	};

	const getFail = error => {
		error &&
			AlertService.alert(
				AlertService.checkMessageType(error.respcode) || ERROR_KEY,
				error,
			);
	};

	return translationService ? (
		<div>
			<div
				className={`${isShow ? "webinar-notification-layer" : ""}`}
				onClick={() => dispatch(setIsShowB2BWebinarNotification(null))}></div>
			<div className={`webinar-notification ${isShow ? "show" : ""}`}>
				<p className="text-center d-block">You have new webinar</p>
				{history.location.pathname.includes("ongoing-webinars") ? (
					<Link
						to={`#`}
						className="mindalay--btn-dark mindalay--btn-link mindalay--btn-small"
						onClick={() => window.location.reload()}>
						Reload
					</Link>
				) : (
					<Link
						to={`/${language}/ongoing-webinars`}
						className="mindalay--btn-dark mindalay--btn-link mindalay--btn-small">
						{translationService.translate("TR_GO")}
					</Link>
				)}

				<audio id="waiting-ringtone" className="d-none">
					<source src={callWeitingRingtone} type="audio/mp3" />
				</audio>
			</div>
		</div>
	) : null;
};

export default withRouter(B2bWebinarNotificationBlock);
